import React, { useCallback } from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import _StyledButton from "BackButton-StyledButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/login_modal/components/BackButton.tsx?styleId=StyledButton";


const StyledButton = /*#__PURE__*/styled("button", null, {
  displayName: "StyledButton",
  styles: _StyledButton
});

type Props = {
  onClick: () => void;
};

export const BackButton: React.FC<Props> = ({ onClick }) => {
  const handleClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      onClick();
    },
    [onClick],
  );

  return (
    <StyledButton onClick={handleClick} aria-label="Back" type="button">
      <Icon name="arrow_back" size={24} />
    </StyledButton>
  );
};
